<template>
<div class="seeker-experience">
    <div class="row">
        <div class="col-default-6 col-v-tablet-12">
            <z-date-picker
                range
                value-type="format"
                placeholder="Период работы*"
                required
                name="work-period"
                ref="work-period"
                v-model="params['work-period']"
            />
        </div>
        <div class="col-default-6 col-v-tablet-12">
            <z-input
                placeholder="Название организации*"
                name="organization-name"
                ref="organization-name"
                v-model="params['organization-name']"
                required
            />
        </div>
    </div>
    <div class="row">
        <div class="col-default-6 col-v-tablet-12">
            <z-input
                placeholder="Должность*"
                name="position"
                ref="position"
                required
                v-model="params.position"
            />
        </div>
        <div class="col-default-6 col-v-tablet-12">
            <z-textarea
                name="duties"
                ref="duties"
                placeholder="Должностные обязанности"
                required
                v-model="params.duties"
                resize
            />
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'seeker-experience',
    props: {
        index: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            params: {
                'work-period': [],
                'organization-name': '',
                position: '',
                duties: ''
            }
        }
    },
    methods: {
        validate () {
            let isValid = true
            const fields = ['work-period', 'organization-name', 'position', 'duties']
            fields.forEach(item => {
                let field = this.$refs[item]
                if (field) {
                    field.validate()
                    if (field.error) isValid = false
                }
            })

            return isValid
        },
        reset () {
            this.params = {
                'work-period': [],
                'organization-name': '',
                position: '',
                duties: ''
            }
        }
    },
    watch: {
        params: {
            handler () {
                let params = {
                    ...this.params,
                    'work-period': `${this.params['work-period'][0]} - ${this.params['work-period'][1]}`
                }

                this.$emit('change', {
                    key: 'experience',
                    index: this.index,
                    value: params
                })
            },
            deep: true
        }
    }
}
</script>

<style lang="scss">
</style>
